import {
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonGroupProps,
  ToggleButtonProps,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { LandReportMapDataLayer, LandReportViewState } from '../LandReportViewProvider'

interface LandReportMapDataLayerPickerProps
  extends ToggleButtonGroupProps,
    Pick<LandReportViewState, 'dataLayer' | 'setDataLayer'> {
  firstButtonProps?: Omit<ToggleButtonProps, 'value'>
  lastButtonProps?: Omit<ToggleButtonProps, 'value'>
}

export const LandReportMapDataLayerPicker = ({
  dataLayer,
  firstButtonProps,
  lastButtonProps,
  setDataLayer,
  ...toggleButtonGroupProps
}: LandReportMapDataLayerPickerProps) => {
  const { t } = useTranslation('@cibo/landmanager/LandReport/Map/DataLayerPicker')

  return (
    <ToggleButtonGroup
      {...toggleButtonGroupProps}
      value={dataLayer}
      onChange={(e, nextLayer) => !!nextLayer && setDataLayer(nextLayer)}
      exclusive
    >
      <ToggleButton value={LandReportMapDataLayer.ACRES} {...firstButtonProps}>
        {t('acres')}
      </ToggleButton>
      <ToggleButton value={LandReportMapDataLayer.PERFORMANCE}>{t('performance')}</ToggleButton>
      <ToggleButton value={LandReportMapDataLayer.SOIL}>{t('soil')}</ToggleButton>
      <ToggleButton value={LandReportMapDataLayer.ELEVATION} {...lastButtonProps}>
        {t('elevation')}
      </ToggleButton>
    </ToggleButtonGroup>
  )
}
